export enum MessageTypeCodes {
    WrongLoginOrPassword = -2,
    RegistrationError = -1,
    Error = 0,
    Success = 1,
    RegistrationSuccess = 2,
    SignInSuccess = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/MessageTypes.ts